import { initNav } from './components/nav.js';
import { initFooter } from './components/footer.js';
import { initRouter } from './router.js';

function bootstrap(): void {
  // Init nav
  initNav();

  // Init footer
  initFooter();

  // Init router (triggers initial page render)
  initRouter();
}

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap);
} else {
  bootstrap();
}
